<template>
  <div class="page product-center-page">
    <HeroCarousel />
    <ProductCategorySection
      v-model="selectedCategoryId"
      anchor-scroll
    />
    <div id="pc-cat-1" class="pc-anchor-target">
      <ProductCenterGrid />
    </div>
    <div id="pc-cat-2" class="pc-anchor-target">
      <ProductCenterGridWearables />
    </div>
    <div id="pc-cat-3" class="pc-anchor-target">
      <ProductCenterGridTws />
    </div>
    <div id="pc-cat-4" class="pc-anchor-target">
      <ProductCenterGridSpeaker />
    </div>
    <div id="pc-cat-5" class="pc-anchor-target">
      <ProductCenterGridOthers />
    </div>
  </div>
</template>

<script>
import HeroCarousel from '@/components/HeroCarousel.vue'
import ProductCategorySection from '@/components/ProductCategorySection.vue'
import ProductCenterGrid from '@/components/ProductCenterGrid.vue'
import ProductCenterGridWearables from '@/components/ProductCenterGridWearables.vue'
import ProductCenterGridTws from '@/components/ProductCenterGridTws.vue'
import ProductCenterGridSpeaker from '@/components/ProductCenterGridSpeaker.vue'
import ProductCenterGridOthers from '@/components/ProductCenterGridOthers.vue'

const VALID_CATS = ['1', '2', '3', '4', '5']

export default {
  name: 'ProductCenter',
  components: {
    HeroCarousel,
    ProductCategorySection,
    ProductCenterGrid,
    ProductCenterGridWearables,
    ProductCenterGridTws,
    ProductCenterGridSpeaker,
    ProductCenterGridOthers,
  },
  data() {
    return {
      selectedCategoryId: '',
    }
  },
  watch: {
    '$route.query.cat': {
      immediate: true,
      handler(cat) {
        const c = cat != null && cat !== '' ? String(cat) : ''
        if (VALID_CATS.includes(c)) {
          this.selectedCategoryId = c
          this.$nextTick(() => this.scrollToAnchor(c))
        }
      },
    },
  },
  methods: {
    scrollToAnchor(catId) {
      const el = document.getElementById(`pc-cat-${catId}`)
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    },
  },
}
</script>

<style scoped>
.page {
  background: #EDEDED;
  min-height: 100vh;
}

#category {
  scroll-margin-top: 80px;
}

.pc-anchor-target {
  scroll-margin-top: 88px;
}
</style>
